// extracted by mini-css-extract-plugin
export default {"container":"error-message_container__yDrz7","error":"error-message_error__FnH+f","message":"error-message_message__4mRNk"};